const _jsxFileName = "C:\\Users\\sz\\Code\\open-inc\\ride-sharing-app\\app\\js\\ride-sharing-admin\\components\\AdminRoute.tsx"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import { AdminLayout } from "@opendash/core";
import { Route, Routes } from "@opendash/router";
import React from "react";
import { useParseUser } from "../../ride-sharing-app";
import { AdminUsersRoute } from "./AdminUsersRoute";

export function AdminRoute() {
  const user = useParseUser();
  const isAdmin = _optionalChain([user, 'optionalAccess', _ => _.get, 'call', _2 => _2("tenantAdmin")]);

  if (!user || !isAdmin) {
    return null;
  }

  return (
    React.createElement(AdminLayout, { contentPadding: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}
      , React.createElement(Routes, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
        , React.createElement(Route, { path: "users", element: React.createElement(AdminUsersRoute, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 18}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}} )
        , React.createElement(Route, { path: "users/:tab", element: React.createElement(AdminUsersRoute, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 19}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}} )
      )
    )
  );
}
